import { useEffect, useState } from 'react';

function useDeferForHydrationMismatch<Value>(value: Value): Value | undefined;
function useDeferForHydrationMismatch<Value>(value: Value, defaultValue: Value): Value;

function useDeferForHydrationMismatch<Value>(value: Value, defaultValue?: Value) {
  const [state, setState] = useState<Value | undefined>(defaultValue);

  useEffect(() => {
    setState(value);
  }, [value]);

  return state;
}

export default useDeferForHydrationMismatch;
